var amdi18n={"__root":{"choose_recovery_strategy":"Is a suitable eID-Client started yet?","waiting_for":"Waiting for"},"__de":{"choose_recovery_strategy":"Ist bereits ein geeigneter eID-Client gestartet?","waiting_for":"Warte auf"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/RecoveryStrategyState_strings.js
// module id = 316
// module chunks = 2